const byScaleCount = (a, b) => b.scales.length - a.scales.length;

export const scaleGrouper = {
  groupScalesByWorkstationsForUser(workstations, scaleGroups, userId) {
    const groupedScalesDisplayInformations = [];
    workstations.forEach((workstation) => {
      const { isOnline } = workstation;
      const workstationScaleGroup = scaleGroups.find((group) => group.workstationId === workstation.workstationId) || {};
      const { scales = [] } = workstationScaleGroup;
      const scalesAvailableToUser = scales
        .filter((scale) => {
          return workstation.userId === userId || scale.shared;
        })
        .map((scale) => ({
          ...scale,
          workstationName: workstation.description,
        }));

      groupedScalesDisplayInformations.push({
        workstationName: workstation.description,
        workstationIsOnline: isOnline,
        scales: scalesAvailableToUser,
      });
    });
    return groupedScalesDisplayInformations.sort(byScaleCount);
  },
};
